import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AbstractService } from './abstract.service';

@Injectable({
  providedIn: 'root'
})
export abstract class AbstractServicePublic extends AbstractService {

  protected getBaseUrlPublic(): string {

    return environment.url + '/public/';
  }
  
}
